export var UploadErrorType;
(function (UploadErrorType) {
    UploadErrorType[UploadErrorType["Unknown"] = 0] = "Unknown";
    UploadErrorType[UploadErrorType["FileTooLarge"] = 1] = "FileTooLarge";
    UploadErrorType[UploadErrorType["OutOfSpace"] = 2] = "OutOfSpace";
    UploadErrorType[UploadErrorType["InvalidFileType"] = 3] = "InvalidFileType";
    UploadErrorType[UploadErrorType["BadConnection"] = 4] = "BadConnection";
    UploadErrorType[UploadErrorType["Timeout"] = 5] = "Timeout";
    UploadErrorType[UploadErrorType["Auth"] = 6] = "Auth";
    UploadErrorType[UploadErrorType["MultipleFiles"] = 7] = "MultipleFiles";
    UploadErrorType[UploadErrorType["UnsupportedType"] = 8] = "UnsupportedType";
})(UploadErrorType || (UploadErrorType = {}));
export var UploadSource;
(function (UploadSource) {
    UploadSource[UploadSource["Button"] = 0] = "Button";
    UploadSource[UploadSource["Capture"] = 1] = "Capture";
    UploadSource[UploadSource["DragAndDrop"] = 2] = "DragAndDrop";
    UploadSource[UploadSource["CreateMenu"] = 3] = "CreateMenu";
    UploadSource[UploadSource["Unknown"] = 4] = "Unknown";
    UploadSource[UploadSource["CreateTile"] = 5] = "CreateTile";
})(UploadSource || (UploadSource = {}));
export var UploadVersion;
(function (UploadVersion) {
    UploadVersion[UploadVersion["uploadV1"] = 0] = "uploadV1";
    UploadVersion[UploadVersion["uploadV2"] = 1] = "uploadV2";
})(UploadVersion || (UploadVersion = {}));
export var UploadStatus;
(function (UploadStatus) {
    UploadStatus[UploadStatus["Started"] = 0] = "Started";
    UploadStatus[UploadStatus["Failed"] = 1] = "Failed";
    UploadStatus[UploadStatus["Unsupported"] = 2] = "Unsupported";
    UploadStatus[UploadStatus["Uploading"] = 3] = "Uploading";
    UploadStatus[UploadStatus["Completed"] = 4] = "Completed";
    UploadStatus[UploadStatus["Cancelled"] = 5] = "Cancelled";
    UploadStatus[UploadStatus["Queued"] = 6] = "Queued";
})(UploadStatus || (UploadStatus = {}));
export var UploadSessionState;
(function (UploadSessionState) {
    UploadSessionState[UploadSessionState["Unknown"] = 0] = "Unknown";
    UploadSessionState[UploadSessionState["Started"] = 1] = "Started";
    UploadSessionState[UploadSessionState["Completed"] = 2] = "Completed";
    UploadSessionState[UploadSessionState["Cancelled"] = 3] = "Cancelled";
    UploadSessionState[UploadSessionState["Failed"] = 4] = "Failed";
})(UploadSessionState || (UploadSessionState = {}));
//# sourceMappingURL=upload.js.map